import { Col, List, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { RiDeleteBinLine, RiEditBoxLine } from "react-icons/ri";

import SearchInput from "../../../../components/searchInput/SearchInput";
import SubmitButton from "../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../components/textComponent/TextComponent";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";

import styles from "./myadds.module.css";
import eventImg from "../../../../assets/eventImg.png";
import image2 from "../../../../assets/staticImages/photographar.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { AdvertisementMiddleware } from "../../../../Store/Middlewares/AdvertisementMiddleware";

const events = [
  {
    title: "Music Services",
    name: "Alex kelvin",
    date: "May 12, 2023",
    price: "$4",
    img: image2,
  },
  {
    title: "Music Services",
    name: "Lucy Grey",
    date: "May 12, 2023",
    price: "$4",
    note: "Transform your home or office into a sanctuary of style and sophistication with our expert Decoration Services.",
  },
  {
    title: "Music Services",
    name: "Steven Mark",
    date: "May 12, 2023",
    price: "$4",
    img: image2,
  },

  {
    title: "Music Services",
    name: "Lucy Grey",
    date: "May 12, 2023",
    price: "$4",
    note: "Transform your home or office into a sanctuary of style and sophistication with our expert Decoration Services.",
  },
];
// const header = (
//   <Row className={styles.row}>
//     <Col className={styles.firstCol}>
//       <TextComponent
//         text="You have 15 Ads"
//         textClass={`${styles.text} ${styles.service}`}
//       />
//     </Col>
//     <Col className={styles.secondCol}>
//       <Row className={styles.leftRow}>
//         <TextComponent text="Created Date" textClass={styles.headertitle} />
//         <TextComponent text="Amount"  textClass={styles.headertitle} />
//         <TextComponent text="Actions"  textClass={styles.headertitle} />
//       </Row>
//     </Col>
//   </Row>
// );

const RenderItem = ({ item, index, onDelete }) => {
  const navigate = useNavigate();

  return (
    <Row className={`${styles.row} ${styles.shadow}`}>
      <Col className={styles.firstCol}>
        <Row className={styles.imgCont}>
          <Col>
            {item?.image && (
              <img src={item?.image} alt="image" className={styles.addImg} />
            )}
          </Col>
          <Col className={styles.addCont}>
            <span>
              <TextComponent
                text={item.title}
                textClass={`${styles.text} ${styles.service}`}
              />
              <TextComponent
                // text={"Created by : " + item.name}
                textClass={`${styles.text} ${styles.name}`}
              />
              {item?.text && (
                <TextComponent text={item.text} textClass={styles.text} />
              )}
            </span>
          </Col>
        </Row>
      </Col>
      {/* <Col className={styles.secondCol}>
        <Row className={styles.leftRow}> */}
      {/* <Col>
            <TextComponent
              text={item.date}
              textClass={`${styles.text} ${styles.service}`}
            />
          </Col>
          <Col>

            <TextComponent
              text={item.price}
              textClass={`${styles.text} ${styles.service}`}
            />
          </Col> */}
      <Col className={styles.secondCol}>
        <span className={styles.group2fourth}>
          {/* <TextComponent text={item.price} textClass={styles.guests} /> */}
          <span
            className={styles.iconsDiv}
            onClick={() => {
              onDelete(item?.id, index);
            }}
            // onClick={()=> console.log(index)}
          >
            <RiDeleteBinLine size={18} color="white" />
          </span>
          <span
            className={styles.iconsDiv}
            onClick={() =>
              navigate("/Advertisement/EditAddvertisement", {
                state: { headrTitle: "Edit Advertisement", item: item },
              })
            }
          >
            <RiEditBoxLine size={18} color="white" />
          </span>
        </span>
        {/* </Col>
        </Row> */}
      </Col>
    </Row>
  );
};

const MyAdds = ({ showCreateBtn }) => {
  const { height, width } = useWindowDimensions();
  const MyAdvertisements = useSelector(
    (state) => state.AdvertisementReducer.MyAdvertisements
  );
  // console.log("MyAdvertisements", MyAdvertisements);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(AdvertisementMiddleware.getAdvertisement());
  }, []);
  const onDelete = (id, index) => {
    dispatch(AdvertisementMiddleware.deleteAdvertisement( id, index ));
  };
  return (
    <>
      <Col className={styles.firstCol}>
        <TextComponent
          text={`You have ${MyAdvertisements?.length} Ads`}
          textClass={`${styles.text} ${styles.service}`}
        />
      </Col>
      <List
        className={styles.list}
        itemLayout={width > 1150 ? "horizontal" : "vertical"}
        dataSource={MyAdvertisements}
        // header={header}
        renderItem={(item, index) => (
          <RenderItem item={item} index={index} onDelete={onDelete} />
        )}
      />
    </>
  );
};

export default MyAdds;
